"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LocationArrowOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path fill-rule="evenodd" d="M14.81 16.393a1 1 0 0 1 .853.769l2.073 9.02 5.896-19.637L5.47 15.243l9.34 1.15zm-.94 1.9 2.441 10.62c.322 1.4 2.253 1.466 2.666.09l6.96-23.178c.35-1.168-.824-2.207-1.908-1.688L2.795 14.307c-1.256.6-.956 2.504.422 2.673l10.654 1.313z" clip-rule="evenodd" stroke="none"></path>';
var LocationArrowOutlineSVG = function LocationArrowOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.LocationArrowOutlineSVG = LocationArrowOutlineSVG;
LocationArrowOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(LocationArrowOutlineSVG);
exports.default = _default;